import request from "@/utils/request";
import Qs from "qs";

// 场地列表
export function venueList(data) {
  return request({
    url: "/place/farm_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加场地
export function venueAdd(data) {
  return request({
    url: "/place/farm_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑场地
export function venueEdit(data) {
  return request({
    url: "/place/farm_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除场地
export function venueDel(data) {
  return request({
    url: "/place/farm_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 场地详情
export function venueInfo(data) {
  return request({
    url: "/place/farm_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 会场预约列表
export function venueApplyList(data) {
  return request({
    url: "/place/farm_apply_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 会场预约详情
export function venueApplyInfo(data) {
  return request({
    url: "/place/farm_apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 会场预约的操作（取消，通过）
export function venueApplyOperation(data) {
  return request({
    url: "/place/farm_apply_operation",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 农场申请审核
export function gardenApplyOperation(data) {
  return request({
    url: "/garden/apply_audit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 农场申请列表
export function gardenApplyList(data) {
  return request({
    url: "/garden/apply_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 农场申请详情
export function gardenApplyInfo(data) {
  return request({
    url: "/garden/apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 农场列表
export function gardenList(data) {
  return request({
    url: "/garden/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加农场
export function gardenAdd(data) {
  return request({
    url: "/garden/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑农场
export function gardenEdit(data) {
  return request({
    url: "/garden/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 农场详情
export function gardenInfo(data) {
  return request({
    url: "/garden/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除农场
export function gardenDel(data) {
  return request({
    url: "/garden/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除农场认领关系
export function delRel(data) {
  return request({
    url: "/garden/del_rel",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 钓台详情
export function fishingInfo(data) {
  return request({
    url: "/garden/fishing_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 钓台配置
export function fishingEdit(data) {
  return request({
    url: "/garden/fishing_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 钓台订单列表
export function fishingOrderLists(data) {
  return request({
    url: "/garden/fishing_order_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 钓台订单退款
export function fishingOrderRefund(data) {
  return request({
    url: "/garden/fishing_order_refund",
    method: "post",
    data: Qs.stringify(data),
  });
}